/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import {batchActions} from 'redux-batched-actions/lib/index';
// actions
import { getClientEmbedsData } from 'state/actions/embedsState/embeds_status';
import { resetEmbedState } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { editEmbed } from 'state/actions/embedsState/embeds_status';

// component
import Embeds from 'pages/dashboard/embeds/embeds';



/* ========== ~~~~~~~~~~ EMBEDS SECTION : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ appStatus, embedsState, sessionStatus, emailCollectionState }) => ({
    currentPage: appStatus.currentPage,
    embedName: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedName,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    selectedEmbedUUID: embedsState.embedAnalytics.selectedEmbedUUID,
    selectedEmbedName: embedsState.embedAnalytics.selectedEmbedName,
    accountUUID: sessionStatus.accountUUID,
    isDataReceived: embedsState.embedsStatus.isDataReceived,
    clientEmbeds: embedsState.embedsStatus.clientEmbeds,
    editPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('manageEmbeds'),
    selectedEmailCollectionEmbedName: emailCollectionState.selectedEmbedEmailStatus.selectedEmbedName,
    productCategory: sessionStatus.productCategory,
    mockupGenerator: sessionStatus.mockupGenerator,
    navigateToEmbedUUID: sessionStatus.embedUUID,
    permissionsReceived: sessionStatus.permissionsReceived
});
// map actions
const mapDispatchToProps = dispatch => ({
    getClientEmbedsData: accountUUID => dispatch(getClientEmbedsData(accountUUID)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    moveToEmbedCreationWithStateReset: () => {
        dispatch(batchActions([
            resetEmbedState(),
            resetContentState({ setInitialContentId: true }),
        ]));
        dispatch(updatePageDetails(`dashboard/embeds/management/getstarted`));
        dispatch(updateStepDetails('getstarted'));
        dispatch(changePage(`dashboard/embeds/management/getstarted`))
    },
    editEmbed: embedUUID => dispatch(editEmbed(embedUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Embeds));
